module.exports = __webpack_public_path__ + "static/media/3wise_logo.11d54421.png";